import { isCeltraCreative } from 'common/js/format-helper';
import { FormatContext, ILoadingStrategy } from '../loading-strategy-factory';

export class CeltraLoadingStrategy implements ILoadingStrategy {
  isRunnable(formatContext: any): boolean {
    return isCeltraCreative(formatContext.config);
  }

  alterConfiguration(formatContext: FormatContext): FormatContext {
    // Do not try to calculate the size of the Celtra / Motionly creative within the iframe
    formatContext.config = {
      ...formatContext.config,
      forceResponsiveHtml: true,
      redirectType: formatContext.config.redirectType || 'celtra'
    };

    return formatContext;
  }

  onAfterRender(formatContext: FormatContext): void {}

  onBeforeRender(formatContext: FormatContext): void {}

  onResize(formatContext: FormatContext): void {}
}
